(() => {
  'use strict';
  if (window.RWCartRules) return;
  let config, catalog = new Map(), tail = Promise.resolve(), epoch = 0, pending = 0, notice;
  const approvals = new WeakMap(), checking = new WeakSet(), wallets = new Set();
  const split = value => String(value || '').split(',').map(v => v.trim()).filter(Boolean);
  const ids = values => (values || []).map(String);
  function readConfig() {
    const node = document.querySelector('[data-rw-cart-rules]');
    config = node ? JSON.parse(node.textContent) : null;
    catalog = new Map();
    for (const product of config?.catalog || []) if (product) for (const variant of product.variants) {
      catalog.set(String(variant.id), { product_id: String(product.id), title: product.title,
        variant_title: variant.title === 'Default Title' ? '' : variant.title });
    }
  }
  const rules = () => config?.enabled ? config.rules.filter(r => r.settings.active &&
    (!split(r.settings.countries).length || split(r.settings.countries).map(s => s.toUpperCase()).includes(config.country))) : [];
  const active = () => rules().length > 0;
  function announce(message, trigger = document.activeElement) {
    if (!trigger?.isConnected) trigger = null;
    if (!notice) {
      notice = document.createElement('dialog');notice.className = 'rw-cart-rules-notice blocks-radius';
      notice.setAttribute('role', 'alertdialog');notice.setAttribute('aria-labelledby', 'rw-cart-rules-title');
      notice.setAttribute('aria-describedby', 'rw-cart-rules-message');
      const heading = document.createElement('h2');heading.id = 'rw-cart-rules-title';heading.className = 'h5';
      const copy = document.createElement('p');copy.id = 'rw-cart-rules-message';
      const close = document.createElement('button');close.type = 'button';close.className = 'btn btn--primary';
      close.addEventListener('click', () => notice.close());notice.append(heading, copy, close);
      notice.addEventListener('keydown', event => {if (event.key === 'Escape') event.stopPropagation();});
      notice.addEventListener('close', () => {
        const owner = notice.returnTarget;
        if (!owner?.isConnected) return;
        const drawer = owner.closest('cart-drawer,quick-view-modal');
        if (drawer?.open) window.FoxTheme?.a11y?.trapFocus(drawer, owner);else owner.focus();
      });
    }
    notice.querySelector('h2').textContent = config.messages.title;
    notice.querySelector('p').textContent = message;
    notice.querySelector('button').textContent = config.messages.close;
    notice.returnTarget = trigger;
    if (notice.open && !notice.isConnected) notice.close();
    if (notice.open) return;
    const container = trigger?.closest('cart-drawer,quick-view-modal,product-info') || document.body;
    container.append(notice);
    if (typeof notice.showModal !== 'function') {window.alert(message);return;}
    window.FoxTheme?.a11y?.removeTrapFocus();notice.showModal();
  }
  const normalize = item => ({ ...catalog.get(String(item.variant_id || item.id)), ...item,
    id: String(item.variant_id || item.id), product_id: String(item.product_id || catalog.get(String(item.variant_id || item.id))?.product_id || ''),
    quantity: Number(item.quantity), plan: String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || item.plan || 0) });
  function matches(rule, item) {
    const s = rule.settings;
    return ids(rule.products).includes(item.product_id) &&
      (!split(s.variants).length || split(s.variants).includes(item.id)) &&
      (!split(s.plans).length || split(s.plans).includes(item.plan)) &&
      (s.purchase !== 'subscription' || item.plan !== '0') && (s.purchase !== 'onetime' || item.plan === '0');
  }
  function invalid(rule) {
    return !rule.products.length || ['variants','plans'].some(k => split(rule.settings[k]).some(id => !/^\d+$/.test(id))) ||
      (rule.type === 'maximum' && (!Number.isInteger(rule.settings.limit) || rule.settings.limit < 1 || !['group','product','variant'].includes(rule.settings.count_mode))) ||
      (rule.type === 'exclusive' && (!rule.other_products.length || ids(rule.products).some(id => ids(rule.other_products).includes(id))));
  }
  const sum = items => items.reduce((total, item) => total + item.quantity, 0);
  const displayName = item => [item?.product_title || item?.title || '', item?.variant_title || ''].filter(Boolean).join(' – ');
  function evaluate(before, after, checkout = false, direct = false) {
    for (const rule of rules()) {
      if (invalid(rule)) return config.messages.invalid;
      const previous = before.filter(i => matches(rule, i)), selected = after.filter(i => matches(rule, i));
      const s = rule.settings;
      if (rule.type === 'maximum') {
        const key = item => s.count_mode === 'group' ? 'all' : s.count_mode === 'variant' ? item.id : item.product_id;
        for (const bucket of new Set(selected.map(key))) {
          const items = selected.filter(i => key(i) === bucket), total = sum(items), current = sum(previous.filter(i => key(i) === bucket));
          if (total > s.limit && (checkout || total > current)) return format(rule, {product: s.display_name || displayName(items[0]), limit: s.limit, current, requested: Math.max(0, total-current), total}, direct);
        }
      } else if (rule.type === 'exclusive') {
        const other = after.filter(i => ids(rule.other_products).includes(i.product_id));
        const oldOther = before.filter(i => ids(rule.other_products).includes(i.product_id));
        if (selected.length && other.length && (checkout || !previous.length || !oldOther.length || sum(selected)+sum(other) > sum(previous)+sum(oldOther))) {
          return format(rule, {product: s.display_name || displayName(selected[0]), other: displayName(other[0]), current: sum(previous), total: sum(selected), requested: Math.max(0,sum(selected)-sum(previous))});
        }
      }
    }
    return '';
  }
  function format(rule, values, direct = false) {
    return (rule.settings.message?.trim() || config.messages[direct && rule.type === 'maximum' ? 'maximum_direct' : rule.type]).replace(/\{(product|limit|current|requested|total|other)\}/g, (_, key) => String(values[key] ?? ''));
  }
  function payload(body) {
    if (typeof body === 'string') return JSON.parse(body);
    if (!(body instanceof FormData) && !(body instanceof URLSearchParams)) throw new Error('Unsupported cart payload');
    const result = {}, items = [], updates = {};
    for (const [key, value] of body.entries()) {
      const item = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/), update = key.match(/^updates\[([^\]]+)\]$/);
      if (item) {(items[Number(item[1])] ||= {})[item[2]] = value;}
      else if (update) updates[update[1]] = value;
      else if (key === 'updates[]') (result.updates ||= []).push(value);
      else result[key] = value;
    }
    if (items.length) result.items = items;
    if (Object.keys(updates).length) result.updates = updates;
    return result;
  }
  function project(cart, data, kind) {
    const before = cart.items.map(normalize), after = before.map(i => ({...i}));
    const make = (id, quantity, plan = 0) => {
      const q = Number(quantity ?? 1);
      if (!/^\d+$/.test(String(id)) || !Number.isInteger(q) || q < 0) throw new Error('Invalid cart quantity');
      return normalize({id, quantity:q, selling_plan:plan});
    };
    if (kind === 'add') {
      for (const item of data.items || [data]) after.push(make(item.id, item.quantity, item.selling_plan));
    } else if (kind === 'change') {
      const index = data.id != null ? after.findIndex(i => i.key === String(data.id) || i.id === String(data.id)) : Number(data.line)-1;
      if (!after[index]) throw new Error('Cart line changed');
      if (data.quantity != null) after[index].quantity = make(after[index].id, data.quantity).quantity;
      if (data.selling_plan != null) after[index].plan = String(data.selling_plan || 0);
    } else if (kind === 'update') {
      for (const [id, quantity] of Object.entries(data.updates || {})) {
        const index = Array.isArray(data.updates) ? Number(id) : after.findIndex(i => i.key === id || i.id === id);
        if (index >= 0 && after[index]) after[index].quantity = make(after[index].id, quantity).quantity;
        else after.push(make(id, quantity));
      }
    }
    return {before, after:after.filter(i => i.quantity > 0)};
  }
  async function getCart() {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(config.root.replace(/\/?$/, '/') + 'cart.js', {credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();if (!Array.isArray(cart.items)) throw new Error('Cart unavailable');return cart;
    } finally {clearTimeout(timer);}
  }
  function invalidate() {
    epoch++;wallets.forEach(w => w.lock());
  }
  function reviewWallets() {wallets.forEach(w => w.schedule());}
  function serialize(task) {const next = tail.then(task, task);tail = next.catch(() => {});return next;}
  function rejected(message, trigger) {
    announce(message, trigger);
    return new Response(JSON.stringify({status:422,errors:message,description:message,rwRule:true}),{status:422,headers:{'Content-Type':'application/json'}});
  }
  function request(url, options) {
    if (!active()) return fetch(url, options);
    const trigger = document.activeElement, kind = new URL(url, location.origin).pathname.match(/\/cart\/(add|change|update)(?:\.js)?$/)?.[1];
    if (!kind) return fetch(url, options);
    let data;
    try {data = payload(options.body);} catch (_) {return Promise.resolve(rejected(config.messages.failure, trigger));}
    if (kind === 'update' && !data.updates) return fetch(url, options);
    pending++;invalidate();
    return serialize(async () => {
      try {
        const cart = await getCart(), {before,after} = project(cart, data, kind), message = evaluate(before, after);
        if (message) return rejected(message, trigger);
        const response = await fetch(url, options);
        // Keep the queue locked until Shopify has completed the mutation/body.
        await response.clone().text();return response;
      } catch (_) {return rejected(config.messages.failure, trigger);}
      finally {pending--;invalidate();reviewWallets();}
    });
  }
  async function check(form, product = false) {
    if (!active()) return '';
    const data = form ? payload(new FormData(form)) : {};
    // Direct product checkout contains the chosen product, not the stored cart.
    if (product) {const items=project({items:[]},data,'add').after;return evaluate([],items,true,true);}
    const cart = await getCart();
    const items = data.updates ? project(cart, data, 'update').after : cart.items.map(normalize);
    return evaluate(items, items, true);
  }
  const signature = form => JSON.stringify(Array.from(new FormData(form)).filter(([name]) => !name.startsWith('attributes[')));
  // Normal cart checkout and non-AJAX product forms. Approvals survive the consent
  // component's requestSubmit replay but are invalidated by every cart mutation.
  document.addEventListener('submit', event => {
    if (!active()) return;
    const form = event.target;if (!(form instanceof HTMLFormElement)) return;
    const path = new URL(form.action, location.origin).pathname;
    const checkout = event.submitter?.name === 'checkout';
    const nativeAdd = /\/cart\/add(?:\.js)?$/.test(path) && (document.body.classList.contains('cart-template') || window.FoxTheme?.settings?.cartType === 'page');
    if (!checkout && !nativeAdd) return;
    const token = epoch + ':' + signature(form);
    if (approvals.get(form) === token && !pending) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (checking.has(form)) return;
    checking.add(form);const submitter = event.submitter;
    serialize(async () => {
      try {
        const revision = epoch, formSignature = signature(form), cart = await getCart();
        const data = payload(new FormData(form));
        const change = nativeAdd ? project(cart,data,'add') : data.updates ? project(cart,data,'update')
          : {before:cart.items.map(normalize),after:cart.items.map(normalize)};
        const message = evaluate(change.before,change.after,checkout);
        if (message) {announce(message,submitter);return;}
        if (revision !== epoch || formSignature !== signature(form) || !form.isConnected) throw new Error('Changed while checking');
        approvals.set(form,epoch+':'+formSignature);form.requestSubmit(submitter?.form === form ? submitter : undefined);
      } catch (_) {announce(config.messages.failure,submitter);} finally {checking.delete(form);}
    });
  }, true);
  // Themes can contain a checkout link as well as a submit button.
  document.addEventListener('click', event => {
    if (!active()) return;
    const link = event.target.closest('a[href]');if (!link) return;
    const url = new URL(link.href,location.origin);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();
    // Use the cart's normal submit flow, including RW Consent, rather than bypassing it.
    const form = document.querySelector('form#cart') || document.querySelector('cart-drawer form[action*="/cart"]');
    const button = Array.from(document.querySelectorAll('[name="checkout"]')).find(b => b.form === form);
    if (form && button) form.requestSubmit(button);else location.assign(config.root.replace(/\/?$/, '/')+'cart'+url.search);
  },true);
  class RWCartRulesPayment extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form') || document.getElementById(this.dataset.formId);
      this.wallet = this.querySelector('[data-rw-rules-wallet]');this.button = this.querySelector('[data-rw-rules-check]');
      this.controller?.abort();this.controller = new AbortController();const options = {signal:this.controller.signal};
      this.product = this.dataset.surface !== 'express_cart';
      this.button.addEventListener('click', () => this.review(true),options);
      this.form?.addEventListener('change', () => {this.lock();this.schedule();},options);
      this.owner = this.form?.closest('product-info,sticky-atc-bar') || this.form;
      this.observer = new MutationObserver(records => {
        if (records.some(r => r.target.matches?.('[name="id"],[name="quantity"],[name="selling_plan"],[name="add"]') || [...r.addedNodes,...r.removedNodes].some(n => n.matches?.('[name="selling_plan"]')))) {this.lock();this.schedule();}
      });
      if (this.owner) this.observer.observe(this.owner,{subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled','aria-disabled']});
      wallets.add(this);this.lock();this.schedule();
    }
    disconnectedCallback() {wallets.delete(this);this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.revision++;}
    lock() {this.revision=(this.revision || 0)+1;if(!this.wallet)return;this.wallet.inert=true;this.button.hidden=false;const fallback=!('inert' in HTMLElement.prototype);this.toggleAttribute('data-fallback',fallback);this.wallet.hidden=fallback;}
    schedule() {clearTimeout(this.timer);this.timer=setTimeout(()=>this.review(false),30);}
    async review(notify) {
      if (this.inFlight) {this.notify = this.notify || notify;return;}
      if (pending) {this.notify = this.notify || notify;return;}
      this.inFlight = true;this.notify = notify || this.notify;const revision=this.revision, version=epoch;
      try {
        if (this.product && !this.form) throw new Error('Product form unavailable');
        const sig = this.form ? signature(this.form) : '';
        const message = await check(this.form,this.product);
        if (!this.isConnected || revision!==this.revision || version!==epoch || (this.form && sig!==signature(this.form))) {this.schedule();return;}
        if (message) {if(this.notify)announce(message,this.button);return;}
        // Shopify owns the wallet. No synthetic click or PaymentButton.init here.
        this.wallet.inert=false;this.wallet.hidden=false;this.button.hidden=true;
      } catch (_) {if(this.notify)announce(config.messages.failure,this.button);}
      finally {this.inFlight=false;this.notify=false;}
    }
  }
  try {readConfig();} catch (_) {config=null;}
  window.RWCartRules = {request, get enabled() {return active();}};
  customElements.define('rw-cart-rules-payment', RWCartRulesPayment);
  ['cart:updated','product-ajax:added','cart:refresh'].forEach(name => document.addEventListener(name,()=>{invalidate();reviewWallets();}));
  window.addEventListener('pageshow',()=>{invalidate();reviewWallets();});
  document.addEventListener('shopify:section:load',()=>{try{readConfig();invalidate();reviewWallets();}catch(_){/* Retain the last valid configuration. */}});
})();
